import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app/app.service';
import { ModalService } from '../_modal';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})

export class ProductsComponent implements OnInit {
  public category: any[] = [];
  public user: any;
  public responsed: any[] = [];
  public errorMsg: { status: boolean, from: string | null, message: string | null, value: any } = {
    status: false,
    from: null,
    message: null,
    value: null
  };
  public states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal"
  ];
  public totalPrice = 0;
  model: any = {
    customer: {
      email: '',
      phone: '',
      fname: '',
      lname: '',
      address1: '',
      address2: '',
      city: '',
      zip: '',
      province: '',
      country_code: 'IN',
      discount: '',
      otp: ''
    },
    products: [
      {
        handle: '',
        title: '',
        id: 0,
        quantity: 1,
        price: 0,
        image: '',
        isCategorySelected: false,
        isProductSelected: false,
        allProducts: []
      }
    ]
  };
  public cart: any[] = [];
  public cartId: any;
  public discountedPrice: any;
  public discountApplied = false;
  public checkoutDetails: any;
  public amountTotal = 0;
  public isCopyButton = false;
  public orderLink: any;
  public baseUrl: any;
  public shippingZonesList: any;
  public shippingRates: any[] = [];
  selectedShippingOption: any;

  constructor(private appService: AppService, private modalService: ModalService, public auth: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.baseUrl = window.location.host.split('.').splice(1).join('.');
    if (!this.baseUrl) {
      this.baseUrl = "ghc.health";
    } else if (this.baseUrl == 'ghc.health') {
      this.baseUrl = "ghc.health";
    } else if (this.baseUrl == 'saturn.health') {
      this.baseUrl = "saturn.health";
    } else {
      this.baseUrl = "ghc.health";
    }

    this.auth.user$.subscribe(
      (profile) => {
        this.user = profile;
        if (profile) {
          localStorage.setItem('user', JSON.stringify(this.user));
        }
      });
    let auth = localStorage.getItem('auth');
    if (!this.user && !auth) {
      this.router.navigateByUrl('/login');
    }
    this.getCategories();
    this.createCartMutation();
    this.shippingZones();
  }


  // createCartMutation
  async createCartMutation() {
    const response = await this.appService.createCartMutation().toPromise();
    this.cartId = response.data.cartCreate.cart.id;
  }

  async getCategories() {
    this.category = (await this.appService.getCategories()).collections.filter((el: any) => (el.title !== "Hidden Items" && el.title !== "OneRupee" && el.products_count !== 0));
  }
  async getProducts(productHandle: any, index: any) {
    let allProducts = (await this.appService.getProductsByCategory(productHandle)).products.filter((el: any) => (!el.tags.includes('hidden')));
    allProducts = this.flatten(allProducts.map((it: any) => it.variants.map((iti: any) => ({ ...it, ...{ variants: [iti] } }))));
    this.model.products[index].allProducts = allProducts;
  }
  updateCategorySelect(handle: any, index: any) {
    this.getProducts(handle, index);
    this.model.products[index].isCategorySelected = true;
    this.model.products[index].handle = handle;
  }
  openModal(id: string) {
    this.modalService.open(id);
  }
  closeModal(id: string) {
    this.modalService.close(id);
  }
  openCart() {
    this.openModal('cart-modal');
  }
  addMore() {
    this.model.products.push({
      handle: '',
      title: '',
      id: 0,
      quantity: 1,
      price: 0,
      image: '',
      isCategorySelected: false,
      isProductSelected: false,
      allProducts: []
    });
  }
  isValidInput(e: any) {
    let x = e.which || e.keyCode;
    return ((x >= 48 && x <= 57) || x === 8 ||
      (x >= 35 && x <= 40) || x === 46 || (x >= 96 && x <= 105) || x === 9) ? true : false;
  }
  flatten(ary: any): any[] {
    var ret: any[] = [];
    for (var i = 0; i < ary.length; i++) {
      if (Array.isArray(ary[i])) {
        ret = ret.concat(this.flatten(ary[i]));
      } else {
        ret.push(ary[i]);
      }
    }
    return ret;
  }
  submit() {
    let removed = this.model.products.filter((el: any) => (el.quantity < 1 || el.id == 'null'));
    if (removed.length > 0) {
      $.notify({
        icon: "pe-7s-bell",
        message: "Quantity can not be less than 1"
      }, {
        type: 'danger',
        timer: 1000,
        placement: {
          from: 'top',
          align: 'right'
        }
      });
    } else {
      $.notify({
        icon: "pe-7s-check",
        message: "Order Successfully Created"
      }, {
        type: 'success',
        timer: 1000,
        placement: {
          from: 'top',
          align: 'right'
        }
      });
    }
  }
  onReset() {
    this.createCartMutation();
    this.discountApplied = false;
    this.cart = [];
    this.isCopyButton = false;
    this.errorMsg = {
      status: false,
      from: null,
      message: null,
      value: null
    };
    this.discountedPrice = null;
    this.totalPrice = 0;
    this.model = {
      customer: {
        email: '',
        phone: '',
        fname: '',
        lname: '',
        address1: '',
        address2: '',
        city: '',
        zip: '',
        province: '',
        country_code: 'IN',
        discount: '',
        otp: ''
      },
      products: [
        {
          handle: '',
          title: '',
          id: 0,
          quantity: 1,
          price: 0,
          image: '',
          isCategorySelected: false,
          isProductSelected: false,
          allProducts: []
        }
      ]
    };
  }
  removeText() {
    this.errorMsg = {
      status: false,
      from: null,
      message: null,
      value: null
    };
  }

  async pincode() {
    let body = {
      "pincode": this.model.customer.zip
    };

    let response = await this.appService.pincodeChecker(body);

    if (response.message.status == 200) {
      this.errorMsg = {
        status: false,
        from: 'pincode',
        message: response.message.data.available_courier_companies[0].etd,
        value: null
      };
    } else {
      this.errorMsg = {
        status: true,
        from: 'pincode',
        message: response.message.link,
        value: null
      };
    }
  }

  async shippingZones() {
    this.shippingRates = [{ name: 'Standard Shipping', price: '49.00' }];
    this.selectedShippingOption = this.shippingRates[0];
  }

  selectedShipping(data: any) {
    this.selectedShippingOption = data;
    this.removeText();
  }

  async updateProductSelect(productId: any, index: any) {
    await this.addToCart(this.model.products[index]);

    for (let p of this.model.products[index].allProducts) {
      if (p.variants[0].id == productId) {
        this.model.products[index].title = p.title;
        this.model.products[index].price = p.variants[0].price;
        this.model.products[index].image = p.images[0].src;
        this.model.products[index].id = productId;
        this.model.products[index].isProductSelected = true;
        break;
      }
    }
  }

  async addToCart(item: any) {
    let cart = [];

    cart.push({
      merchandiseId: `gid://shopify/ProductVariant/${item.id}`,
      quantity: item.quantity
    });

    await this.appService.addToCartMutation(cart, this.cartId).toPromise();
    await this.createCartArray();
  }

  async createCartArray() {
    this.cart = [];
    this.totalPrice = 0;

    const response = await this.appService.getCartMutation(this.cartId).toPromise();
    this.totalPrice = response.data.cart.estimatedCost.subtotalAmount.amount;

    if (response.data.cart.discountCodes[0]?.applicable) {
      this.discountedPrice = response.data.cart;
    }

    for (let edge of response.data.cart.lines.edges) {
      this.cart.push({
        lineId: edge.node.id,
        id: edge.node.merchandise.product.id,
        title: edge.node.merchandise.product.title,
        quantity: edge.node.quantity,
        price: edge.node.merchandise.priceV2.amount,
        image: edge.node.merchandise.image.originalSrc,
        variantId: edge.node.merchandise.id
      });
    }
  }

  async deleteItemFromCart(item: any, index: any) {
    this.model.products.splice(index, 1);
    if (!this.model.products.length) {
      this.addMore();
    }

    const exists = this.cart.find(obj => obj.title === item.title);
    if (exists) {
      await this.appService.removeFromCartMutation(exists.lineId, this.cartId).toPromise();
    }
    await this.createCartArray();
  }

  async updateCart(items: any) {
    let lineItems = [];

    const exists = this.cart.find(obj => obj.title === items.title);
    exists.quantity = items.quantity;

    for (let item of this.cart) {
      lineItems.push({
        id: item.lineId,
        quantity: item.quantity
      });
    }

    await this.appService.updateLineMutation(lineItems, this.cartId).toPromise();
    await this.createCartArray();
  }

  async applyDiscount() {
    this.discountApplied = false;
    let response = await this.appService.applyDiscountCodeMutation([this.model.customer.discount], this.cartId).toPromise();
    await this.createCartArray();

    if (response.data.cartDiscountCodesUpdate.cart.discountCodes[0].applicable) {
      if (this.discountedPrice && this.discountedPrice.estimatedCost.totalAmount.amount < 100) {
        return this.discountApplied = true;
      }
      return this.errorMsg = {
        status: false,
        from: 'discount',
        message: `Discount applied! Updated Cart Value is ₹ ${response.data.cartDiscountCodesUpdate.cart.estimatedCost.totalAmount.amount}`,
        value: response.data.cartDiscountCodesUpdate.cart.estimatedCost.totalAmount.amount
      };

    } else {
      this.errorMsg = {
        status: true,
        from: 'discount',
        message: 'Please enter valid discount code',
        value: null
      }
    }
  }

  async placeOrder() {
    let cartTotalValue = 0;
    await this.createCartArray();
    this.amountTotal = 0;

    if (!this.cart.length) {
      return this.errorMsg = {
        status: true,
        from: 'cart',
        message: "Cart can't be empty",
        value: null
      };
    }

    let minValue = this.selectedShippingOption.min_order_subtotal ? this.selectedShippingOption.min_order_subtotal : 0;
    let maxValue = this.selectedShippingOption.max_order_subtotal ? this.selectedShippingOption.max_order_subtotal : 100000;

    this.responsed = [];
    const lines = this.cart.map((a) => {
      this.amountTotal = this.amountTotal + (parseFloat(a.price) * a.quantity);
      return {
        title: a.title,
        price: a.price,
        variant_id: a.variantId.match(/\d/g).join(""),
        quantity: a.quantity
      };
    });

    const customer = {
      first_name: this.model.customer.fname,
      last_name: this.model.customer.lname,
      address1: this.model.customer.address1,
      address2: this.model.customer.address2,
      phone: this.model.customer.phone,
      email: this.model.customer.email,
      city: this.model.customer.city,
      province: this.model.customer.province,
      country: "India",
      zip: this.model.customer.zip
    };

    const discount = this.discountedPrice ? [{
      code: this.discountedPrice.discountCodes[0].code,
      amount: this.amountTotal - parseInt(this.discountedPrice.estimatedCost.totalAmount.amount),
      type: 'amount'
    }] : [];

    if (this.discountedPrice) {
      cartTotalValue = parseFloat(this.discountedPrice.estimatedCost.totalAmount.amount);
    } else {
      cartTotalValue = this.amountTotal;
    }
    if (cartTotalValue > minValue && cartTotalValue < maxValue) {
      this.appService.createCrmOrder(lines, customer, discount, this.selectedShippingOption).subscribe(async res => {
        this.responsed.push(res);
        await this.submit();
        await this.onReset();
        await this.openModal('custom-modal-1');
      }, err => {
        this.errorMsg = {
          status: true,
          from: 'cart',
          message: 'Please check cart and coupon again',
          value: null
        }
      });
    } else {
      this.errorMsg = {
        status: true,
        from: 'cart',
        message: `Cart Value should be between ${minValue} - ${maxValue}`,
        value: null
      }
    }
  }

  generateOrderLink() {
    this.responsed = [];
    this.amountTotal = 0;
    let link;
    const lines = this.cart.map((a) => {
      this.amountTotal = this.amountTotal + (parseFloat(a.price) * a.quantity);
      return {
        title: a.title,
        price: a.price,
        variant_id: a.variantId.match(/\d/g).join(""),
        quantity: a.quantity
      };
    });
    this.isCopyButton = true;

    if (this.errorMsg.from == 'discount' && this.errorMsg.status == false) {
      console.log(this.errorMsg.from == 'discount' && this.errorMsg.status == false)
      link = `https://${this.baseUrl}/cart/${lines.filter(el => el.quantity > 0).map(item => `${item.variant_id}:${item.quantity}`).join(',')}?checkout%5Bemail%5D=${this.model.customer.email}&checkout%5Bshipping_address%5D%5Bfirst_name%5D=${this.model.customer.fname}&checkout%5Bshipping_address%5D%5Blast_name%5D=${this.model.customer.lname}&checkout%5Bshipping_address%5D%5Baddress1%5D=${this.model.customer.address1}&checkout%5Bshipping_address%5D%5Baddress2%5D=${this.model.customer.address2}&checkout%5Bshipping_address%5D%5Bcity%5D=${this.model.customer.city}&checkout%5Bshipping_address%5D%5Bzip%5D=${this.model.customer.zip}&checkout%5Bshipping_address%5D%5Bcountry%5D=${this.model.customer.country_code}&checkout%5Bshipping_address%5D%5Bprovince%5D=&checkout%5Bshipping_address%5D%5Bphone%5D=${this.model.customer.phone}&discount=${this.model.customer.discount}`;
    } else {
      link = `https://${this.baseUrl}/cart/${lines.filter(el => el.quantity > 0).map(item => `${item.variant_id}:${item.quantity}`).join(',')}?checkout%5Bemail%5D=${this.model.customer.email}&checkout%5Bshipping_address%5D%5Bfirst_name%5D=${this.model.customer.fname}&checkout%5Bshipping_address%5D%5Blast_name%5D=${this.model.customer.lname}&checkout%5Bshipping_address%5D%5Baddress1%5D=${this.model.customer.address1}&checkout%5Bshipping_address%5D%5Baddress2%5D=${this.model.customer.address2}&checkout%5Bshipping_address%5D%5Bcity%5D=${this.model.customer.city}&checkout%5Bshipping_address%5D%5Bzip%5D=${this.model.customer.zip}&checkout%5Bshipping_address%5D%5Bcountry%5D=${this.model.customer.country_code}&checkout%5Bshipping_address%5D%5Bprovince%5D=&checkout%5Bshipping_address%5D%5Bphone%5D=${this.model.customer.phone}`;
    }
    this.appService.shortenLink(link).subscribe(res => {
      this.orderLink = res.link.link;
    });
  }

  onCopy() {
    navigator.clipboard.writeText(this.orderLink);
    $.notify({
      icon: "pe-7s-check",
      message: "Link Copied"
    }, {
      type: 'success',
      timer: 1000,
      placement: {
        from: 'top',
        align: 'right'
      }
    });
  }
}